import React from 'react';
import './App.scss';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import SignIn from './pages/SignIn';
import SignInContinue from './pages/SignInContinue';
import Register from './pages/Register';
import CreateAccount from './pages/CreateAccount';
import ForgotPassword from './pages/ForgotPassword';
import Verify from './pages/Verify';
import Buy from './pages/Buy';
import Rent from './pages/Rent';
import BuyDetails from './pages/BuyDetails';
import RentDetails from './pages/RentDetails';
import GetPreQualified from './pages/GetPreQualified';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsUse from './pages/TermsUse';
import MortgageCalculator from './pages/MortgageCalculator';
import CalculateYourBuyAbility from './pages/CalculateYourBuyAbility';
import ContactUs from './pages/ContactUs';
import Help from './pages/Help';
import HelpList from './pages/HelpList';
import HelpDetail from './pages/HelpDetail';
import Career from './pages/Career';
import CareerDetail from './pages/CareerDetail';
import FindAgent from './pages/FindAgent';
import AboutUs from './pages/AboutUs';
import Sell from './pages/Sell';
import Blogs from './pages/Blogs';
import BecomeAgent from './pages/BecomeAgent';
import BecomeAgentCreateAccount from './pages/BecomeAgentCreateAccount';
import BlogsDetails from './pages/BlogsDetails';
import Profile from './pages/Profile';
import MyAgents from './pages/MyAgents';
import ConnectWithAgentStep from './pages/ConnectWithAgentStep';
import SavedHomes from './pages/SavedHomes';
import RecentlyViewed from './pages/RecentlyViewed';
import SavedSearches from './pages/SavedSearches';
import CompareHomes from './pages/CompareHomes';
import NewsEvents from './pages/NewsEvents';
import NewsEventsDetails from './pages/NewsEventsDetails';
import Commercial from './pages/Commercial';
import CommercialDetails from './pages/CommercialDetails';
import Search from './pages/Search';
import ScrollToTop from './component/ScrollToTop';
import ResetPassword from './pages/ResetPassword';
import CookiePolicy from './pages/CookiePolicy';
function App() {
  return (
     <Router>
      <ScrollToTop/>     
        <Routes>
          <Route path="/" element={<Home />} /> 
          <Route path="/sign-in" element={<SignIn />} /> 
          <Route path="/sign-in-continue" element={<SignInContinue />} /> 
          <Route path="/create-account" element={<Register />} /> 
          <Route path="/create-account-continue" element={<CreateAccount />} /> 
          <Route path="/forgot-password" element={<ForgotPassword  />} />
          <Route path="/verify" element={<Verify  />} />
          <Route path="/buy" element={<Buy  />} />
          <Route path="/rent" element={<Rent  />} />
          <Route path="/commercial" element={<Commercial />} />
          <Route path="/buy-details/:slug" element={<BuyDetails />} />
          <Route path="/rent-details/:slug" element={<RentDetails />} />
          <Route path="/commercial-details/:slug" element={<CommercialDetails />} />
          <Route path="/search" element={<Search />} />
          <Route path="/get-pre‑qualified" element={<GetPreQualified />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/terms-of-use" element={<TermsUse />} />
          <Route path="/mortgage-calculator" element={<MortgageCalculator />} />
          <Route path="/calculate-your-buy-ability" element={<CalculateYourBuyAbility />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/help" element={<Help />} />
          <Route path="/help-list" element={<HelpList />} />
          <Route path="/help-detail" element={<HelpDetail />} />
          <Route path="/career" element={<Career />} />
          <Route path="/career/:id" element={<CareerDetail />} />
          <Route path="/find-an-agent" element={<FindAgent />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/sell" element={<Sell />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/become-an-agent" element={<BecomeAgent />} />
          <Route path="/become-an-agent-create-an-account" element={<BecomeAgentCreateAccount />} />
          <Route path="/blogs-details" element={<BlogsDetails />} />
          <Route path="/blogs-details/:slug" element={<BlogsDetails />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/my-agents" element={<MyAgents />} />
          <Route path="/connect-with-an-agent-step" element={<ConnectWithAgentStep />} />
          <Route path="/saved-homes" element={<SavedHomes />} />
          <Route path="/recently-viewed" element={<RecentlyViewed />} />
          <Route path="/saved-searches" element={<SavedSearches />} />
          <Route path="/compare-homes" element={<CompareHomes />} />
          <Route path="/news-events" element={<NewsEvents />} />
          <Route path="/news-events-details/:slug" element={<NewsEventsDetails />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/news-details/:slug" element={<NewsEventsDetails />} />
        </Routes>
    </Router>
  );
}

export default App;
